import { TemplatePage } from './types';

const restaurantPromoPage: TemplatePage = {
  header: {
    color: '#B5D6DB',
    icon: 'images/video-templates/food-restaurants.jpg',
    title: 'Restaurant Promo Video Templates ',
    title_meta: 'Easy-to-Edit Restaurant Promo Video Templates',
    description_meta:
      'Spread the word about your restaurant, bar, or cafe online with Wave.video’s collection of 50+ editable ' +
      'restaurant promo video templates.',
    description:
      'Spread the word about your restaurant, bar, or cafe online with Wave.video’s collection of editable restaurant ' +
      'promo video templates. Gain loyal customers for your restaurant business with the power of video.'
  },
  footer: {
    category: 'Restaurant Promo',
    description:
      'With Wave.video’s wide range of easily customizable restaurant promo video templates, you will be able to ' +
      'take your video content to the next level without breaking a sweat. Create thumb-stopping videos for your website, ' +
      'blog, social media, or email newsletter in a matter of minutes.'
  },
  content: [
    {
      type: 'templates',
      title: 'restaurant promo',
      search: { name: 'restaurant promo' }
    },
    {
      type: 'stocks',
      title: 'restaurant promo',
      search: { name: 'restaurant promo' }
    },
    { type: 'calendar' }
  ]
} as TemplatePage;

export default restaurantPromoPage;
